
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import wellKnownSymbol$1 from './well-known-symbol.js';
import iterators from './iterators.js';

var wellKnownSymbol = wellKnownSymbol$1;
var Iterators = iterators;

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};

export { isArrayIteratorMethod as default };
//# sourceMappingURL=is-array-iterator-method.js.map
